import { render, staticRenderFns } from "./ArticleGroupDialog.vue?vue&type=template&id=a8c11eaa&"
import script from "./ArticleGroupDialog.vue?vue&type=script&lang=ts&"
export * from "./ArticleGroupDialog.vue?vue&type=script&lang=ts&"
import style0 from "./ArticleGroupDialog.vue?vue&type=style&index=0&id=a8c11eaa&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports